import { render, staticRenderFns } from "./add-permit-price.vue?vue&type=template&id=247bb734&"
import script from "./add-permit-price.vue?vue&type=script&lang=js&"
export * from "./add-permit-price.vue?vue&type=script&lang=js&"
import style0 from "./add-permit-price.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports